var FreeChipNames = {
    freeChipsList: 'FREE_CHIPS_LIST',
    freeChipEnded: 'FREE_CHIP_ENDED',
    freeChipWin: 'FREE_CHIP_WIN',
    freeChipInfo: 'FREE_CHIP_INFO',
};
var FreeChipPopupTKeys = {
    FREE_CHIPS_LIST: 'FREE_CHIP',
    FREE_CHIP_INFO: 'FREE_CHIP_INFO',
    FREE_CHIP_WIN: 'FREE_CHIPS_IN_COST',
    FREE_CHIP_ENDED: 'FREE_CHIP_HAS_ENDED',
};
var FreeChipPopupActions = {
    USE_NOW: 'USE_NOW',
    USE_LATER: 'USE_LATER',
};
var FreeBetEndedMethodName = 'FreeBetEnded';
var FreeBetAwardedMethodName = 'FreeBetAwarded';

export { FreeBetAwardedMethodName, FreeBetEndedMethodName, FreeChipNames, FreeChipPopupActions, FreeChipPopupTKeys };
